import React from "react";
import languageConstants from "../appConfig/languageConstants";

const VanityNote = () => {
    return (
        <div className="vanity-note">
            <label>
                <strong>Note: </strong>{languageConstants.note.vanityNote}
            </label>
        </div>
    );
};

export default VanityNote;
